import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.3505 5.00122c1.3401.00736 6.126.05889 7.4632.41961.86.23166 1.5383.91332 1.7675 1.77999.3765 1.41299.4141 4.20708.4179 4.75168v.1866c-.0038.5448-.0414 3.3394-.4179 4.7517-.2292.8658-.9075 1.5483-1.7675 1.78-1.3743.37-6.3916.414-7.5667.4193h-.4949c-1.1751-.0053-6.19241-.0493-7.56669-.4193-.86-.2317-1.53833-.9142-1.76833-1.78-.37575-1.4123-.41332-4.2069-.41708-4.7517v-.1866c.00376-.5446.04133-3.33869.41708-4.75168.23-.86667.90833-1.54833 1.76833-1.77999 1.33713-.36072 6.12299-.41225 7.46319-.41961h.7019zM9.95405 9.07189v5.94751l5.22745-2.9734-5.22745-2.97411z",
    fill: "currentColor"
  }));
});